/**
 * Runtime configuration.
 *
 * One image is built per commit and deployed to every tenant server, so
 * per-tenant values (API host, tenant name) cannot be baked in at build time
 * the way plain REACT_APP_* vars are. Instead the container writes
 * `/config.js` from its environment before nginx starts, and index.html loads
 * that file ahead of the bundle.
 *
 * Build-time values stay as the fallback, so `yarn start`, `yarn test` and any
 * server that sets no environment keep behaving exactly as before.
 */
type RuntimeConfig = Record<string, string | undefined>;

function readRuntimeConfig(): RuntimeConfig {
  if (typeof window === "undefined") return {};
  return ((window as unknown as { __APP_CONFIG__?: RuntimeConfig })
    .__APP_CONFIG__ || {}) as RuntimeConfig;
}

/**
 * `key` is the name without the REACT_APP_ prefix (API_URL, TENANT, ...).
 * The entrypoint writes every key it knows about, using "" for the ones the
 * server left unset — those fall through to the build-time value.
 */
export function runtimeValue(
  key: string,
  buildTimeValue?: string
): string | undefined {
  const value = readRuntimeConfig()[key];
  return value ? value : buildTimeValue;
}
